// extracted by mini-css-extract-plugin
module.exports = {"root":"footer-module--root--1fUhu","pipe":"footer-module--pipe--2aGjI","holiday":"footer-module--holiday--3ECjq"};